<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />

    <v-card class="v-card-bottom-30">
      <v-card-title class="py-5">
        <h4>{{ use_language.home_page }}</h4> <v-icon>mdi-chevron-right</v-icon><span
          class="font-weight-regular body-1">{{ use_language.report_profit }}</span>
        <v-spacer />
      </v-card-title>
    </v-card>

    <v-card class="v-card-bottom-30">
      <v-card-title>
        <v-icon size="20" color="primary">fa-sliders-h</v-icon><span class="py-2 ml-3">{{ use_language.search }}</span>
        <v-spacer />
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2" lg="1" xl="1">
            <span>{{ use_language.date }} : </span>
          </v-col>
          <v-col cols="12" md="2">
            <v-menu ref="search_menu_date_from" v-model="search_menu_date_from" :close-on-content-click="false"
              :return-value.sync="search_date_from" transition="scale-transition" offset-y max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field :value="computed_search_date_from" @change="value => computed_search_date_from = value"
                  autocomplete="off" :label="use_language.start_" outlined prepend-inner-icon="mdi-calendar" readonly hide-details
                  dense v-on="on">
                  <template v-slot:label> <span>{{ use_language.start_ }}</span> </template>
                </v-text-field>
              </template>
              <v-date-picker v-model="search_date_from"
                @input="search_menu_date_from = false, $refs.search_menu_date_from.save(search_date_from)" no-title
                :allowed-dates="allowedDates" class="my-0">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2">
            <v-menu ref="search_menu_date_to" v-model="search_menu_date_to" :close-on-content-click="false"
              :return-value.sync="search_date_to" transition="scale-transition" offset-y max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field :value="computed_search_date_to" @change="value => computed_search_date_to = value"
                  autocomplete="off" :label="use_language.end" outlined prepend-inner-icon="mdi-calendar" readonly hide-details
                  dense v-on="on">
                  <template v-slot:label> <span>{{ use_language.end }}</span> </template>
                </v-text-field>
              </template>
              <v-date-picker v-model="search_date_to"
                @input="search_menu_date_to = false, $refs.search_menu_date_to.save(search_date_to)" no-title
                :allowed-dates="allowedDates" class="my-0">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn dark color="primary" :loading="loading_btn" @click="search_data_profit()" class="mr-3">{{
              use_language.search
              }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row justify="start" align="center" class="my-7 margin-card-status">
      <v-col cols="12" sm="3" md="4" lg="3" align="left" class="px-2">
        <v-card>
          <v-card-title :style="{ fontSize: '16px' }" class="px-2">
            {{ use_language.total_sales }}
          </v-card-title>
          <v-divider />
          <v-card-title class="px-1">
            <v-row align="center">
              <v-col align="center" class="px-1">
                <h4 class='text-gray'> <span v-if="profitTotal.length != 0">{{
                  format_number(profitTotal["orderTotalAmount"]) }}</span> <span
                    v-if="profitTotal.length == 0">0</span> ฿
                </h4>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3" md="4" lg="3" align="left" class="px-2">
        <v-card>
          <v-card-title :style="{ fontSize: '16px' }" class="px-2">
            {{ use_language.total_productCost }}
          </v-card-title>
          <v-divider />
          <v-card-title class="px-1">
            <v-row align="center">
              <v-col align="center" class="px-1">
                <h4 class='text-red'> <span v-if="profitTotal.length != 0">{{
                  format_number(profitTotal["productCostPrice"])
                    }}</span> <span v-if="profitTotal.length == 0">0</span> ฿</h4>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
       <v-col cols="12" sm="3" md="4" lg="3" align="left" class="px-2">
        <v-card>
          <v-card-title :style="{ fontSize: '16px' }" class="px-2">
            {{ use_language.sale_expense+'(order)' }}
          </v-card-title>
          <v-divider />
          <v-card-title class="px-1">
            <v-row align="center">
              <v-col align="center" class="px-1">
                <h4 class='text-red'> <span v-if="profitTotal.length != 0">{{
                  format_number(profitTotal["orderExpenseCost"])
                    }}</span> <span v-if="profitTotal.length == 0">0</span> ฿</h4>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
       <v-col cols="12" sm="3" md="4" lg="3" align="left" class="px-2">
        <v-card>
          <v-card-title :style="{ fontSize: '16px' }" class="px-2">
            {{ use_language.profit_from_sales }}
          </v-card-title>
          <v-divider />
          <v-card-title class="px-1">
            <v-row align="center">
              <v-col align="center" class="px-1">
                <h4 class='text-red' v-if="profitTotal.orderTotalAmount+profitTotal.productCostPrice+profitTotal.orderExpenseCost<0"> 
                   {{ format_number(profitTotal.orderTotalAmount+profitTotal.productCostPrice+profitTotal.orderExpenseCost)}} ฿</h4>
                    <h4 class='text-green'>  
                      {{ format_number(profitTotal.orderTotalAmount+profitTotal.productCostPrice+profitTotal.orderExpenseCost)}} ฿</h4>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3" md="4" lg="3" align="left" class="px-2">
        <v-card>
          <v-card-title :style="{ fontSize: '16px' }" class="px-2">
            {{ use_language.sale_expense }}
          </v-card-title>
          <v-divider />
          <v-card-title class="px-1">
            <v-row align="center">
              <v-col align="center" class="px-1">
                <h4 class='text-red'> <span v-if="profitTotal.length != 0">{{
                  format_number(profitTotal["totalExpenseCost"]-profitTotal["orderExpenseCost"])
                    }}</span> <span v-if="profitTotal.length == 0">0</span> ฿</h4>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3" md="4" lg="3" align="left" class="px-2">
        <v-card>
          <v-card-title :style="{ fontSize: '16px' }" class="px-2">
            {{ use_language.total_profit }}
          </v-card-title>
          <v-divider />
          <v-card-title class="px-1">
            <v-row align="center">
              <v-col align="center" class="px-1">
                <h4 class='text-green'  v-if="profitTotal.profit>=0"> <span>{{ format_number(profitTotal["profit"])
                    }}</span>
               
                </h4>
                <h4 class='text-red' v-else> {{ format_number((profitTotal["profit"])) }} ฿
                </h4>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3" md="4" lg="3" align="left" class="px-2">
        <v-card>
          <v-card-title :style="{ fontSize: '16px' }" class="px-2">
            {{ use_language.total_AdministrativeExpenseCost }}
          </v-card-title>
          <v-divider />
          <v-card-title class="px-1">
            <v-row align="center">
              <v-col align="center" class="px-1">
                <h4 class='text-red'> <span v-if="profitTotal.length != 0">{{ format_number(TotalManagementExpense * -1)
                    }}</span> <span v-if="profitTotal.length == 0">0</span> ฿</h4>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3" md="4" lg="3" align="left" class="px-2">
        <v-card>
          <v-card-title :style="{ fontSize: '16px' }" class="px-2">
            {{ use_language.total_profitNet }}
          </v-card-title>
          <v-divider />
          <v-card-title class="px-1">
            <v-row align="center">
              <v-col align="center" class="px-1">
                <h4 class='text-green' v-if="profitTotal.profit - TotalManagementExpense >= 0"> {{
                  format_number((profitTotal["profit"] - TotalManagementExpense)) }} ฿</h4>
                <h4 class='text-red' v-else> {{ format_number((profitTotal["profit"] - TotalManagementExpense)) }} ฿
                </h4>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="v-card-bottom-30">
      <v-card-title>
        <v-icon size="20" color="success">fa-receipt</v-icon><span class="py-2 ml-3">{{ use_language.info_order
          }}</span>
        <v-spacer />
      </v-card-title>
      <v-divider />
      <v-card-text class="padding-mobile-display">

            <v-data-table  :headers="profitReportSummaryTable_headers"
            :items="orderSummary" class="elevation-0 packhai-border-table" hide-default-footer
            :items-per-page="10000" mobile-breakpoint="0">

            
            <template v-slot:item.totalSale="{ item }">
               {{ format_price(item.totalSale) }} 
            </template>
            <template v-slot:item.totalProfit="{ item }">
             {{ format_price(item.totalProfit) }} 
            </template>
            
          </v-data-table>


         <v-tabs v-model="tab_list" class="mt-4"  >
          <v-tabs-slider color="red"></v-tabs-slider>
          <v-tab @click="tab_list = 0" class="box-shadow1"  ><span>B2B</span></v-tab>
          <v-tab @click="tab_list = 1" class="box-shadow1" ><span> B2C</span></v-tab>
         
        </v-tabs>

        <div v-if="tab_list==0" class="padding-mobile-display" style="height: 500px; overflow-y: auto;">
          <v-data-table v-if="b2bItems_list.length>0" :headers="profitReportTable_headers"
            :items="b2bItems_list" class="elevation-0 packhai-border-table" hide-default-footer
            :items-per-page="10000" mobile-breakpoint="0">

            <template v-slot:item.id="{ item }">
              <a v-if="item.id" style="text-decoration: underline" @click="detail_page(item.id)">{{ format_order_id(item.id) }}</a>

            </template>
            <template v-slot:item.orderTotalAmount="{ item }">
              <span>{{ format_price(item.orderTotalAmount) }}</span>
            </template>
            <template v-slot:item.createdDatetime="{ item }">
             <span v-if="item.createdDatetime">  {{ set_format_date(item.createdDatetime) }}</span> 
            </template>
            <template v-slot:item.sendToExpressDateTime="{ item }">
              <span v-if="item.sendToExpressDateTime">  {{ set_format_date(item.sendToExpressDateTime) }}</span> 
             
            </template>
            <template v-slot:item.productCostPrice="{ item }">
              <span v-show="Number(item.productCostPrice) !== 0"
                :class="item.productCostPrice >= 0 ? 'text-green' : 'text-red'">{{ format_price(item.productCostPrice)
                }}</span>
            </template>
            <template v-slot:item.totalExpenseCost="{ item }">
              <span v-show="Number(item.totalExpenseCost) !== 0"
                :class="format_price(item.totalExpenseCost) >= 0 ? 'text-green' : 'text-red'">{{ format_price(
                  item.totalExpenseCost) }}</span>
            </template>
            <template v-slot:item.profit="{ item }">
              <span :class="item.profit >= 0 ? 'text-green' : 'text-red'">{{ format_price(item.profit) }}</span>
            </template>
            <template v-slot:item.unpaid="{ item }">
              <span v-if="item.unpaid > 0">{{ format_price(item.unpaid) }}</span>
            </template>
            <template v-slot:item.waitPayment="{ item }">
              <span v-if="item.waitPayment > 0">{{ format_price(item.waitPayment) }}</span>
            </template>
            <template v-slot:item.remark="{ item }">
              <span class="text-red">{{ item.remark }}</span>
            </template>
            <template v-slot:item.customerName="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="width: 250px" class="text-truncate">
                    <span>{{ item.customerName }}</span>
                  </div>

                </template>
                <span>
                  <span>{{ item.customerName }}</span>
                </span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>

         <div   v-else-if="tab_list==1" class="padding-mobile-display" style="height: 500px; overflow-y: auto;">
          <v-data-table v-if="b2cItems_list.length>0" :headers="profitReportTable_headers"
            :items="b2cItems_list" class="elevation-0 packhai-border-table" hide-default-footer
            :items-per-page="10000" mobile-breakpoint="0">

            <template v-slot:item.id="{ item }">
              <a v-if="item.id" style="text-decoration: underline" @click="detail_page(item.id)">{{ format_order_id(item.id) }}</a>

            </template>
            <template v-slot:item.orderTotalAmount="{ item }">
              <span>{{ format_price(item.orderTotalAmount) }}</span>
            </template>
            <template v-slot:item.createdDatetime="{ item }">
               <span v-if="item.createdDatetime">  {{ set_format_date(item.createdDatetime) }}</span> 
            </template>
            <template v-slot:item.sendToExpressDateTime="{ item }">
                 <span v-if="item.sendToExpressDateTime">  {{ set_format_date(item.sendToExpressDateTime) }}</span> 
 
            </template>
            <template v-slot:item.productCostPrice="{ item }">
              <span v-show="Number(item.productCostPrice) !== 0"
                :class="item.productCostPrice >= 0 ? 'text-green' : 'text-red'">{{ format_price(item.productCostPrice)
                }}</span>
            </template>
            <template v-slot:item.totalExpenseCost="{ item }">
              <span v-show="Number(item.totalExpenseCost) !== 0"
                :class="format_price(item.totalExpenseCost) >= 0 ? 'text-green' : 'text-red'">{{ format_price(
                  item.totalExpenseCost) }}</span>
            </template>
            <template v-slot:item.profit="{ item }">
              <span :class="item.profit >= 0 ? 'text-green' : 'text-red'">{{ format_price(item.profit) }}</span>
            </template>
            <template v-slot:item.unpaid="{ item }">
              <span v-if="item.unpaid > 0">{{ format_price(item.unpaid) }}</span>
            </template>
            <template v-slot:item.waitPayment="{ item }">
              <span v-if="item.waitPayment > 0">{{ format_price(item.waitPayment) }}</span>
            </template>
            <template v-slot:item.remark="{ item }">
              <span class="text-red">{{ item.remark }}</span>
            </template>
            <template v-slot:item.customerName="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="width: 250px" class="text-truncate">
                    <span>{{ item.customerName }}</span>
                  </div>

                </template>
                <span>
                  <span>{{ item.customerName }}</span>
                </span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>

      </v-card-text>
    </v-card>
    <div class="v-card-bottom-30">
      <v-row >
        <v-col cols="4">
          <v-card>
            <v-card-title :style="{ fontSize: '16px' }" class="px-2">
              {{ use_language.paid }}
            </v-card-title>
            <v-divider />
            <v-card-title class="px-1">
              <v-row align="center">
                <v-col align="center" class="px-1">
                  <h4 class='text-green'> <span v-if="profitTotal.length != 0">{{ format_price(paidAmount) }}</span> ฿
                  </h4><br>
                  <span>{{ paidCount }} {{ use_language.item_unit }}</span>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card>
            <v-card-title :style="{ fontSize: '16px' }" class="px-2">
              {{ use_language.order_tab_count_wait_payment }}
            </v-card-title>
            <v-divider />
            <v-card-title class="px-1">
              <v-row align="center">
                <v-col align="center" class="px-1">
                  <h4 class='text-orange'> <span v-if="profitTotal.length != 0">{{ format_price(waitPaymentAmount) }}</span> ฿</h4><br>
                  <span>{{ waitPaymentCount }} {{ use_language.item_unit }}</span>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card>
            <v-card-title :style="{ fontSize: '16px' }" class="px-2">
              {{ use_language.wait_create_payment }}
            </v-card-title>
            <v-divider />
            <v-card-title class="px-1">
              <v-row align="center">
                <v-col align="center" class="px-1">
                  <h4 class='text-red'> <span v-if="profitTotal.length != 0">{{ format_price(unpaidAmount) }}</span> ฿
                  </h4><br>
                  <span>{{ unpaidCount }} {{ use_language.item_unit }}</span>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-card class="v-card-bottom-30">
      <v-card-title>
        <v-icon size="20" color="success">fa-money-bill-wave</v-icon><span class="py-2 ml-3">{{
          use_language.sale_expense
          }}</span>
        <v-spacer />
      </v-card-title>
      <v-divider />
      <v-card-text class="padding-mobile-display">

        <div class="padding-mobile-display" style="height: 350px; overflow-y: auto;">
          <v-data-table :headers="expenseReportTable_headers" :items="expenseItems"
            class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000" mobile-breakpoint="0">
            <template v-slot:item.invoiceDate="{ item }">
              {{ set_format_date_time(item.invoiceDate) }}
            </template>
            <template v-slot:item.num="{ item }">
              {{ (expenseItems.indexOf(item)) + 1 }}
            </template>
            <template v-slot:item.idText="{ item }">
              <a style="text-decoration: underline" @click="detail_po(item.idText)">{{ item.idText }}</a>
            </template>
            <template v-slot:item.amountBeforeVat="{ item }">
              {{ format_price(item.amountBeforeVat) }}
            </template>
            <template v-slot:item.remark="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="width: 250px" class="text-truncate">
                    <span>{{ item.remark }}</span>
                  </div>

                </template>
                <span>
                  <span>{{ item.remark }}</span>
                </span>
              </v-tooltip>
            </template>
            <template v-slot:item.referenceNumber="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="width: 250px" class="text-truncate">
                    <span>{{ item.referenceNumber }}</span>
                  </div>

                </template>
                <span>
                  <span>{{ item.referenceNumber }}</span>
                </span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>

      </v-card-text>
    </v-card>

    <v-card class="v-card-bottom-30">
      <v-card-title class="py-4">
        <v-icon size="20" color="success">fa-chart-area</v-icon> <span class="ml-3">{{
          use_language.proportion_sale_expense
          }}</span>
        <v-spacer />
      </v-card-title>
      <v-divider />
      <v-card-text class="padding-mobile-display">
        <v-row justify="start" align="center">
          <v-col cols="12" sm="12" md="12" lg="6" align="left" v-if="chartExpenseTypeSummary.length > 0">
            <GChart type="PieChart" :settings="{ packages:['corechart'] }" :data="chartExpenseTypeSummary"
              :options="chartPieOptions.chart" />
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="6" align="left" v-if="expenseTypeSummary.length > 0">
            <div class="padding-mobile-display" style="overflow-y: auto;">
              <v-data-table :headers="piechartexpenseTable_headers" :items="expenseTypeSummary"
                class="elevation-0 packhai-border-table " hide-default-footer :items-per-page="10000"
                mobile-breakpoint="0">
                <template v-slot:item.percentcal="{ item }">
                  {{ get_percent_expense(item.amountBeforeVat) }} %
                </template>
                <template v-slot:item.amountBeforeVat="{ item }">
                  {{ format_price(item.amountBeforeVat) }}
                </template>

              </v-data-table>
            </div>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>

    <v-card class="v-card-bottom-30" v-if="manageExpenseItems.length > 0">
      <v-card-title>
        <v-icon size="20" color="success">fa-money-bill-wave</v-icon><span class="py-2 ml-3">{{
          use_language.administrative_expenses }}</span>
        <v-spacer />
      </v-card-title>
      <v-divider />
      <v-card-text class="padding-mobile-display">

        <div class="padding-mobile-display" style="height: 350px; overflow-y: auto;">
          <v-data-table :headers="expenseManagementReportTable_headers" :items="manageExpenseItems"
            class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000" mobile-breakpoint="0">
            <template v-slot:item.invoiceDate="{ item }">
              {{ set_format_date_time(item.invoiceDate) }}
            </template>
            <template v-slot:item.num="{ item }">
              {{ (manageExpenseItems.indexOf(item)) + 1 }}
            </template>
            <template v-slot:item.idText="{ item }">
              <a style="text-decoration: underline" @click="detail_po(item.idText)">{{ item.idText }}</a>
            </template>
            <template v-slot:item.amountBeforeVat="{ item }">
              {{ format_price(item.amountBeforeVat) }}
            </template>
            <template v-slot:item.remark="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="width: 250px" class="text-truncate">
                    <span>{{ item.remark }}</span>
                  </div>

                </template>
                <span>
                  <span>{{ item.remark }}</span>
                </span>
              </v-tooltip>
            </template>
            <template v-slot:item.referenceNumber="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="width: 250px" class="text-truncate">
                    <span>{{ item.referenceNumber }}</span>
                  </div>

                </template>
                <span>
                  <span>{{ item.referenceNumber }}</span>
                </span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>

      </v-card-text>
    </v-card>

    <v-card class="v-card-bottom-30" v-if="manageExpenseTypeSummary.length > 0">
      <v-card-title class="py-4">
        <v-icon size="20" color="success">fa-chart-area</v-icon> <span class="ml-3">{{
          use_language.proportion_of_manage_expense }}</span>
        <v-spacer />
      </v-card-title>
      <v-divider />
      <v-card-text class="padding-mobile-display">
        <v-row justify="start" align="center">
          <v-col cols="12" sm="12" md="12" lg="6" align="left" v-if="chartManageExpenseTypeSummary.length > 0">
            <GChart type="PieChart" :settings="{ packages:['corechart'] }" :data="chartManageExpenseTypeSummary"
              :options="chartPieOptions.chart" />
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="6" align="left">
            <div class="padding-mobile-display" style="overflow-y: auto;">
              <v-data-table :headers="piechartexpenseManagementTable_headers" :items="manageExpenseTypeSummary"
                class="elevation-0 packhai-border-table " hide-default-footer :items-per-page="10000"
                mobile-breakpoint="0">
                <template v-slot:item.percentcal="{ item }">
                  {{ get_percent_manage_expense(item.amountBeforeVat) }} %
                </template>
                <template v-slot:item.amountBeforeVat="{ item }">
                  {{ format_price(item.amountBeforeVat) }}
                </template>

              </v-data-table>
            </div>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>


    <v-card class="v-card-bottom-30">
      <v-card-title class="py-4">
        <v-icon size="20" color="success">fa-chart-area</v-icon> <span class="ml-3">{{
          use_language.proportion_of_expense_profit }}</span>
        <v-spacer />
      </v-card-title>
      <v-divider />
      <v-card-text class="padding-mobile-display">
        <v-row justify="start" align="center" class="my-7 margin-card-status">
          <v-col cols="12" sm="12" md="12" lg="6" align="left" v-if="chartTotalSummary.length > 0">

            <GChart type="PieChart" :settings="{ packages:['corechart'] }" :data="chartTotalSummary"
              :options="chartPieOptions.chart" />
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="6" align="left" v-if="chartTotalSummary.length > 0">
            <div class="padding-mobile-display" style="overflow-y: auto;">
              <v-data-table :headers="piechartexpensePerProfitTable_headers" :items="expensePerProfit"
                class="elevation-0 packhai-border-table " hide-default-footer :items-per-page="10000"
                mobile-breakpoint="0">

                <template v-slot:item.amount="{ item }">
                  {{ format_price(item.amount) }}
                </template>

              </v-data-table>
            </div>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Loading from '@/website/components/Loading'
import axios from 'axios'
import { GChart } from 'vue-google-charts'
import { orderService_dotnet } from '@/website/global'
import { format_number, format_order_id, format_price, get_languages } from '@/website/global_function'
import { header_token } from '@/website/backend/token'


export default {
  components: {
    Loading,
    GChart
  },

  data: () => ({
    page_loading: true,
    loading: false,
    loading_btn: false,
    paidCount :0,
    paidAmount: 0,
    waitPaymentCount:0,
    waitPaymentAmount: 0,
    unpaidCount:0,
    unpaidAmount: 0,
    use_language: null,
    set_language: null,
    tab_list:0,
    //search
    search_menu_date_from: false,
    search_date_from: null,
    search_menu_date_to: false,
    search_date_to: null,
    b2bItems_list: [],
    b2cItems_list:[],
    profitTotal: [],
    profitLast: 0,
    expenseItems: [],
    expenseTypeSummary: [],

    manageExpenseItems: [],
    manageExpenseTypeSummary: [],


    TotalManagementExpense: 0,
    chartExpenseTypeSummary: [],
    chartManageExpenseTypeSummary: [],
    chartTotalSummary: [],
    expensePerProfit: [],
    sumExpensePerProfit: 0,
    chartPieOptions: {
      chart: {
        // title: "ยอดขายตามช่องทางการขาย",
        pieHole: 10.4,
        width: '100%',
        height: 450,
        legend: { position: 'bottom' }
      }
    },

  }),

  computed: {
    computed_search_date_from() {
      return this.formatDates(this.search_date_from)
    },

    computed_search_date_to() {
      return this.formatDates(this.search_date_to)
    },

    profitReportSummaryTable_headers() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.category, align: 'center', value: 'orderType', width: '10px', sortable: false },
        { text: this.use_language.quantity, align: 'center', value: 'countOrder', width: '100px', sortable: false },
        { text: this.use_language.total_sales, align: 'right', value: 'totalSale', width: '150px', sortable: false },
        { text: this.use_language.sales + '(%)', align: 'right', value: 'totalSalePercent', width: '150px', sortable: false },
        { text: this.use_language.profit_from_sales, align: 'right', value: 'totalProfit', width: '150px', sortable: false },
        { text: this.use_language.profit_from_sales + '(%)', align: 'right', value: 'totalProfitPercent', width: '150px', sortable: false },
      ]
    },
    profitReportTable_headers() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.number, align: 'center', value: 'no', width: '10px', sortable: false },
        { text: 'OrderID', align: 'center', value: 'id', width: '90px', sortable: false },
        { text: this.use_language.receiver_name, align: 'left', value: 'customerName', width: '250px', sortable: false },
        { text: this.use_language.build_time, align: 'center', value: 'createdDatetime', width: '100px', sortable: false },
        { text: this.use_language.delivery_time, align: 'center', value: 'sendToExpressDateTime', width: '100px', sortable: false },
        { text: this.use_language.sales, align: 'right', value: 'orderTotalAmount', width: '100px', sortable: false },
        { text: this.use_language.product_cost_price_2, align: 'right', value: 'productCostPrice', width: '100px', sortable: false },
        { text: this.use_language.other_expenses, align: 'right', value: 'totalExpenseCost', width: '100px', sortable: false },
        { text: this.use_language.profit, align: 'right', value: 'profit', width: '100px', sortable: false },
        { text: this.use_language.awaiting_payment, align: 'right', value: 'waitPayment', width: '100px', sortable: false },
        { text: this.use_language.unpaid, align: 'right', value: 'unpaid', width: '100px', sortable: false },
        { text: this.use_language.note, align: 'left', value: 'remark', width: '250px', sortable: false },
      ]
    },
    expenseReportTable_headers() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.number, align: 'center', value: 'num', width: '50px', sortable: false },
        { text: this.use_language.bill_no, align: 'center', value: 'idText', width: '90px', sortable: false },
        { text: this.use_language.invoice_issue_date, align: 'center', value: 'invoiceDate', width: '150px', sortable: false },
        { text: this.use_language.expense_type, align: 'left', value: 'expenseType', width: '250px', sortable: false },
        { text: this.use_language.ref_number, align: 'left', value: 'referenceNumber', sortable: false },
        { text: this.use_language.note, align: 'left', value: 'remark', sortable: false },
        { text: this.use_language.amount_money, align: 'right', value: 'amountBeforeVat', width: '100px', sortable: false },
      ]
    },
    piechartexpenseTable_headers() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.expense_type, align: 'left', value: 'expenseType', width: '33%', sortable: false },
        { text: this.use_language.amount_money, align: 'center', value: 'amountBeforeVat', width: '33%', sortable: false },
        { text: this.use_language.percent, align: 'center', value: 'percentcal', width: '33%', sortable: false },
      ]
    },
    piechartexpensePerProfitTable_headers() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.details, align: 'left', value: 'topic', sortable: false },
        { text: this.use_language.amount_money, align: 'right', value: 'amount', width: '150px', sortable: false },
        { text: this.use_language.percent, align: 'right', value: 'percent', width: '150px', sortable: false },
      ]
    },
    expenseManagementReportTable_headers() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.number, align: 'center', value: 'num', width: '50px', sortable: false },
        { text: this.use_language.bill_no, align: 'center', value: 'idText', width: '90px', sortable: false },
        { text: this.use_language.invoice_issue_date, align: 'center', value: 'invoiceDate', width: '150px', sortable: false },
        { text: this.use_language.expense_type, align: 'left', value: 'expenseType', width: '250px', sortable: false },
        { text: this.use_language.ref_number, align: 'left', value: 'referenceNumber', sortable: false },
        { text: this.use_language.note, align: 'left', value: 'remark', sortable: false },
        { text: this.use_language.amount_money, align: 'right', value: 'amountBeforeVat', width: '100px', sortable: false },
      ]
    },
    piechartexpenseManagementTable_headers() {
      if (!this.use_language) return []
      return [
        { text: this.use_language.expense_type, align: 'left', value: 'expenseType', width: '33%', sortable: false },
        { text: this.use_language.amount_money, align: 'center', value: 'amountBeforeVat', width: '33%', sortable: false },
        { text: this.use_language.percent, align: 'center', value: 'percentcal', width: '33%', sortable: false },
      ]
    },
  },

  async created() {

    //เก็บภาษามาไว้ใน use_language
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    this.set_date() 
    await this.get_data_expense()
    this.page_loading = false
  },

  methods: {
    format_number,
    format_order_id,
    format_price,
    get_languages,

    allowedDates: val => val <= new Date().toISOString().substr(0, 10),

    formatDates(date) {
      if (date == null) {
        return null
      } else {
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      }
    },

    set_format_date(val) {
      if (val != null) {
        var date_tmp = val.substring(0, 10)
        const date_split = date_tmp.split('-');
        var time_tmp = val.substring(11, 19)
        var set_dattime = date_split[2] + '-' + date_split[1] + '-' + date_split[0]
        return set_dattime
      } else {
        return ""
      }
    },

    get_percent_expense(val) {
      if (val != null) {
        var percent = (val / (this.profitTotal.totalExpenseCost * -1)) * 100
        return percent.toFixed(2)
      } else {
        return ""
      }
    },
    get_percent_manage_expense(val) {
      if (val != null) {
        var percent = (val / this.TotalManagementExpense) * 100
        return percent.toFixed(2)
      } else {
        return ""
      }
    },


    set_format_date_time(val) {
      if (val != null) {
        var date_tmp = val.substring(0, 10)
        const date_split = date_tmp.split('-');
        var time_tmp = val.substring(11, 19)
        var set_dattime = date_split[2] + '-' + date_split[1] + '-' + date_split[0] + ' ' + time_tmp
        return set_dattime
      } else {
        return ""
      }
    },

    set_zero_date(num) {
      var num_tmp
      if (parseInt(num) >= 10) {
        num_tmp = num
      } else {
        num_tmp = '0' + num
      }
      return num_tmp
    },

    set_date() {
      var dateObj = new Date();
      var month = dateObj.getUTCMonth() + 1; //months from 1-12
      var day = dateObj.getUTCDate();
      var year = dateObj.getUTCFullYear();

      var firstDay = year + "-" + this.set_zero_date(month) + '-01'
      var nowdate = year + "-" + this.set_zero_date(month) + "-" + this.set_zero_date(day)

      this.search_date_from = firstDay
      this.search_date_to = nowdate
    },
    
    detail_page(id) {
      window.open('order-detail?id=' + id, '_blank');
    },
    detail_po(id) {
      window.open('addExpense?id=' + id, '_blank');
    },
  
    async get_data_expense() {

      try {
        this.loading_btn = true

        await axios.all([
          axios.post(orderService_dotnet + 'PO/get-po-summary', {
            "dateFrom": this.search_date_from,
            "dateTo": this.search_date_to,
            "shopID": localStorage.getItem("shop_id"),
          }, { headers: header_token }),
          axios.post(orderService_dotnet + 'Order/get-profit-report', {
            "dateFrom": this.search_date_from,
            "dateTo": this.search_date_to,
            "shopID": localStorage.getItem("shop_id"),
          }, { headers: header_token })
        ])
        .then(axios.spread((expense_response ,profit_response ) => {
          if (profit_response.status == 200 && expense_response.status==200) {
            this.orderSummary = profit_response.data.summary;
            this.b2bItems_list = []
            this.b2cItems_list = []
            this.profitTotal = {
              orderTotalAmount: 0,
              productCostPrice: 0,
              profit: 0,
              totalExpenseCost: 0,
              orderExpenseCost:0,
            }
            this.profitTotal.orderExpenseCost = profit_response.data.totalExpenseCost;
            if(expense_response.data.saleExpenseItem.length>0){
              this.profitTotal.totalExpenseCost =  expense_response.data.saleExpenseItem.reduce((sum, item) => sum + item.amountBeforeVat, 0)*-1;
            }
           
            this.profitTotal.orderTotalAmount = profit_response.data.orderTotalAmount;
            this.profitTotal.profit = profit_response.data.profit;
            this.profitTotal.productCostPrice = profit_response.data.productCostPrice;
            this.profitTotal.profit = this.profitTotal.orderTotalAmount  + this.profitTotal.productCostPrice + this.profitTotal.totalExpenseCost;

            this.b2bItems_list = profit_response.data.b2bItems
            this.b2cItems_list = profit_response.data.b2cItems
         
            this.paidAmount = profit_response.data.paid;
            this.paidCount = profit_response.data.paidCount;

            this.waitPaymentAmount =profit_response.data.waitPayment;
            this.waitPaymentCount =profit_response.data.waitPaymentCount;

            this.unpaidAmount =profit_response.data.unpaid;
            this.unpaidCount = profit_response.data.unpaidCount;

            this.chartTotalSummary.push([this.use_language.section, this.use_language.amount_money])
            this.chartTotalSummary.push([this.use_language.total_productCost, Math.abs(this.profitTotal["productCostPrice"])])
            this.chartTotalSummary.push([this.use_language.sale_expense + '(order)', Math.abs(this.profitTotal["orderExpenseCost"])])
            this.chartTotalSummary.push([this.use_language.sale_expense + '(' + this.use_language.other + ')', Math.abs(this.profitTotal["totalExpenseCost"])- Math.abs(this.profitTotal["orderExpenseCost"])])
            this.expensePerProfit.push({ "topic": this.use_language.total_productCost, "amount": Math.abs(this.profitTotal["productCostPrice"]) },)
             this.expensePerProfit.push({ "topic": this.use_language.sale_expense + '(order)', "amount": Math.abs(this.profitTotal["orderExpenseCost"]) },)
            this.expensePerProfit.push({ "topic": this.use_language.sale_expense + '(' + this.use_language.other + ')', "amount": Math.abs(this.profitTotal["totalExpenseCost"])- Math.abs(this.profitTotal["orderExpenseCost"]) },)
         

            this.expenseItems = []
            this.expenseTypeSummary = []
            this.manageExpenseItems = []
            this.manageExpenseTypeSummary = []

            this.TotalManagementExpense = 0
            this.profitLast = 0

            this.expenseItems = expense_response.data.saleExpenseItem
            this.expenseTypeSummary = expense_response.data.saleExpenseTypeSummary

            this.manageExpenseItems = expense_response.data.managementExpenseItem
            this.manageExpenseTypeSummary = expense_response.data.managementExpenseTypeSummary

            this.TotalManagementExpense = expense_response.data.managementExpenseTypeSummary.reduce((sum, item) => sum + item.amountBeforeVat, 0);
            this.chartExpenseTypeSummary = this.expenseTypeSummary.map(item => ([
              item.expenseType,
              item.amountBeforeVat
            ]));
            this.chartExpenseTypeSummary.unshift([this.use_language.sale_expense, this.use_language.spending_amount])

            this.chartManageExpenseTypeSummary = this.manageExpenseTypeSummary.map(item => ([
              item.expenseType,
              item.amountBeforeVat
            ]));
            this.chartManageExpenseTypeSummary.unshift([this.use_language.administrative_expenses, this.use_language.spending_amount])



            this.profitLast = this.profitTotal["profit"] - this.TotalManagementExpense

            this.chartTotalSummary.push([this.use_language.administrative_expenses, this.TotalManagementExpense])
            if (this.profitLast > 0) {
              this.chartTotalSummary.push([this.use_language.total_profitNet, this.profitLast])
            }

            this.expensePerProfit.push({ "topic": this.use_language.administrative_expenses, "amount": this.TotalManagementExpense },)

            if (this.profitTotal.orderTotalAmount > 0) {
              if (this.profitLast >= 0) {
                this.expensePerProfit.push({ "topic": this.use_language.total_profitNet, "amount": this.profitLast });
                this.expensePerProfit.forEach(element => {
                  var percent = (element.amount / this.profitTotal.orderTotalAmount) * 100
                  element.percent = percent.toFixed(2)
                });
              } 
              else 
              {
                var sumTotalCost = 0
                sumTotalCost = this.expensePerProfit.reduce((sum, item) => sum + item.amount, 0);
                var percent = this.profitLast / sumTotalCost * 100;
                this.expensePerProfit.push({ "topic": this.use_language.total_profitNet, "amount": this.profitLast, "percent": percent.toFixed(2) });
              }
            }
            else {
              this.expensePerProfit.push({ "topic": this.use_language.total_profitNet, "amount": this.profitLast });
              this.expensePerProfit.forEach(element => {
                element.percent = ""
              });

            }







          } else {
            this.$swal({
              type: 'warning',
              title: this.use_language.warning_error_try_again,
            })
          }
          this.loadingAdd = false
        })).catch((error) => {
           
          this.loading_btn = false
          this.$swal({
            type: 'warning',
            title: this.use_language.error_please_contact_department,

          })
          
          return false;
        });

        this.loading_btn = false
      } catch (e) {

        this.loading_btn = false
        this.$swal({
          type: 'warning',
          title: this.use_language.error_please_contact_department,
          text: e,
        })
      
      }
    },



    async search_data_profit() {
      this.chartTotalSummary = []
      this.expensePerProfit = [] 
      await this.get_data_expense()

    },
  }
}
</script>
<style scoped>
/* >>>.v-dialog {
        -webkit-box-shadow: none;
        box-shadow: none;
    } */
.v-tab:not(.v-tab--active){
   background: white !important;
}
.v-tab.v-tab {
     
    background: #f7f7f7;
}
.box-shadow1 {
  border: 1px solid #d7d7d7;
  border-radius: 0px;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%);
  background: white;
}
.box-shadow-picker {
  border: 1px solid;
  border-radius: 5px;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%);
  background: white;
}
>>>.bex48-logo {
  width: 12.533vw;
  height: 11.2vw;
  display: block;
  /* margin: 8.8vw auto 1.6vw; */
  margin: 1.6vw auto 1.6vw;
}

>>>.slide-fade-enter-active {
  transition: all .3s ease;
}

>>>.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

>>>.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateY(10px);
  opacity: 0;
}

.packhai-border-table {

  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.packhai-border-table thead {
  color: #f4f6ff;
}

.packhai-border-table thead tr th {
  font-weight: bold;
  font-size: 2rem;
}

.return-order-table {
  width: 100%;
}

.padding-for-order-dialog {
  padding: 0px !important;
}

>>>.margin-card-r-10 {
  margin-right: 0px;
}

>>>.margin-card-l-10 {
  margin-left: 0px;
}

@media screen and (min-width: 768px) {
  .return-order-table {
    width: 300px;
  }

  .padding-for-order-dialog {
    padding: 15px !important;
  }

  .margin-card-r-3 {
    margin-right: 10px;
  }

  .margin-card-l-3 {
    margin-left: 10px;
  }
}

.packhai-border-preview {
  border-top: solid 1px black;
  border-left: solid 1px black;
  border-right: solid 1px black;
  border-bottom: solid 1px black;
  border-radius: 10px;
}

.px-15 {
  padding-left: 15px;
  padding-right: 15px;
}

.fz-12 {
  font-size: 12px !important;
}

.fz-14 {
  font-size: 14px !important;
}

.text-green {
  color: green;
  font-weight: bold;
}

.text-red {
  color: red;
  font-weight: bold;
}

.text-orange {
  color: #ff8d22;
  font-weight: bold;
}

.text-gray {
  color: #7c0e77;
  font-weight: bold;
}

.custom-title {
  padding: 5 !important;
}
</style>
